import React, { useEffect } from "react";
import { CtaTracker } from "@core/services/CtaTracker";
import { useTranslation } from "react-i18next";
import DatePollCreationWorkspace from "../components/DatePollCreationWorkspace";
import { SEOHead } from "../components/SEOHead";

/**
 * Page de création de sondage de dates avec IA
 * Utilise le workspace complet avec toute l'intelligence pour les dates
 */
export default function DateCreator() {
  const { t } = useTranslation("common");
  console.log("🔧 DateCreator MOUNTED - using DatePollCreationWorkspace");
  // A7 : ouverture de la création, avec sa provenance (?ref=) si présente.
  useEffect(() => {
    CtaTracker.trackCreateStarted("create", window.location.search);
  }, []);
  return (
    <>
      <SEOHead title={t("seo_title_create")} />
      <DatePollCreationWorkspace />
    </>
  );
}
